/* Extracted from snippets/global-product-card.liquid.
   It was inlined once per product card - 8 identical copies (~84KB)
   on a single product page, each registering its own DOMContentLoaded
   listener. Contains no Liquid, so it is safe as a static asset.
   Loaded once, deferred, from layout/theme.liquid. */
// Colour dots on product cards (9 Oct 2026): one listener on the document instead of one per dot,
// bound at page load. Cards added later (collection scroll-loading, search) were never bound, so a
// tap there opened the product page instead of switching the photo. Same behaviour as before:
// on phones (778px and under) a tap switches the card's photo and link and stays on the page;
// on larger screens it switches the link and follows it.
function updateMainLinkUrl(container, productUrl, imageUrl) {
  const mainLink = container.querySelector('#main-link');
  if (mainLink && mainLink.getAttribute('href') !== productUrl) {
    mainLink.setAttribute('href', productUrl);
  }
  // If the screen width is less than 768px, replace the image
  if (window.innerWidth < 768 && imageUrl) {
    const mainImage = container.querySelector('.primary img');
    if (mainImage) {
      // The card image has a srcset, which the browser prefers over src.
      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('src', imageUrl);
    }
  }
}

document.addEventListener('click', function(event) {
  const link = event.target.closest ? event.target.closest('.no-click-link') : null;
  if (!link) return;
  if (window.innerWidth <= 778) event.preventDefault();
  const container = link.closest('.card-container');
  const productUrl = link.getAttribute('data-product-url');
  if (container && productUrl) {
    updateMainLinkUrl(container, productUrl, link.getAttribute('data-image'));
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body');

  if (!body || !body.classList.contains('t-collection')) {
    return;
  }
  const productContainers = document.querySelectorAll('.card-badge');

  function updateBadges(container, variantId) {
    const allBadges = container.querySelectorAll('.product-badge');
    let hasBackorderBadge = false;
    let hasSoldOutBadge = false;
    let hasLastPieceBadge = false;
    let hasBackInStockBadge = false;
    let hasPreorderBadge = false;
    let hasNewInBadge = false;
    const hasCustomBadge = false; // was referenced below but never declared

    // Checking for badges
    allBadges.forEach(badge => {
      const badgeVariantId = badge.getAttribute('data-variant-id');
      if (badgeVariantId === variantId) {
        if (badge.classList.contains('backorder')) {
          hasBackorderBadge = true;
        }
        if (badge.classList.contains('soldout')) {
          hasSoldOutBadge = true;
        }
        if (badge.classList.contains('last-piece')) {
          hasLastPieceBadge = true;
        }
        if (badge.classList.contains('back-in-stock')) {
          hasBackInStockBadge = true;
        }
        if (badge.classList.contains('preorder')) {
          hasPreorderBadge = true;
        }
        if (badge.classList.contains('is-new-in')) {
          hasNewInBadge = true;
        }
      }
    });
    
    allBadges.forEach(badge => {
      const badgeVariantId = badge.getAttribute('data-variant-id');
      if (badgeVariantId === variantId) {
        if (hasBackorderBadge) {
          badge.style.display = badge.classList.contains('backorder') ? 'block' : 'none';
        } else if (hasSoldOutBadge) {
          badge.style.display = badge.classList.contains('soldout') ? 'block' : 'none';
        } else if (hasLastPieceBadge) {
          badge.style.display = badge.classList.contains('last-piece') ? 'block' : 'none';
        } else if (hasBackInStockBadge) {
          badge.style.display = badge.classList.contains('back-in-stock') ? 'block' : 'none';
        } else if (hasPreorderBadge) {
          badge.style.display = badge.classList.contains('preorder') ? 'block' : 'none';
        } else if (hasNewInBadge) {
          badge.style.display = badge.classList.contains('is-new-in') ? 'block' : 'none';
        } else {
          // Show all badges of the current version, including general ones
          badge.style.display = 'block';
        }
      } else {
        // For badges of other options
        badge.style.display = 'none';
      }
    });

    // We remove common badges if there is a “last-piece” or “sold-out”
    container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
      badge.style.display = hasLastPieceBadge || hasCustomBadge || hasSoldOutBadge ? 'none' : 'block';
    });
  }

  function showFirstVariantBadges(container) {
    let hasBackorderBadge = false;
    let hasSoldOutBadge = false;
    let hasLastPieceBadge = false;
    let hasBackInStockBadge = false;
    let hasPreorderBadge = false;
    let hasNewInBadge = false;
    

    // Checking the presence of the 'last-piece' badge for the first option
    container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
      if (badge.classList.contains('backorder')) {
        hasBackorderBadge = true;
      }
      if (badge.classList.contains('soldout')) {
        hasSoldOutBadge = true;
      }
      if (badge.classList.contains('last-piece')) {
        hasLastPieceBadge = true;
      }
      if (badge.classList.contains('back-in-stock')) {
        hasBackInStockBadge = true;
      }
      if (badge.classList.contains('preorder')) {
        hasPreorderBadge = true;
      }
      if (badge.classList.contains('is-new-in')) {
        hasNewInBadge = true;
      }
    });

    // If the first option has a 'backorder', show only that
    if (hasBackorderBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('backorder') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none'; // Hide common badges if there is a 'backorder'
      });
       // If the first option has a 'sold out', show only that
    } else if (hasSoldOutBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('soldout') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none';
      });
    } else if (hasLastPieceBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('last-piece') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none';
      });
    } else if (hasBackInStockBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('back-in-stock') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none';
      });
    } else if (hasPreorderBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('preorder') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none';
      });
    } else if (hasNewInBadge) {
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = badge.classList.contains('is-new-in') ? 'block' : 'none';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'none';
      });
    } else {
      // If 'last-piece' or 'sold-out' is missing, show all the badges of the first option and one common badge
      container.querySelectorAll('.variant-badge.default-badge').forEach(badge => {
        badge.style.display = 'block';
      });
      container.querySelectorAll('.product-badge:not(.variant-badge)').forEach(badge => {
        badge.style.display = 'block';
      });
    }
  }

  function hideAllBadges(container) {
    container.querySelectorAll('.product-badge').forEach(badge => {
      badge.style.display = 'none'; // Hide all badges
    });
  }

  productContainers.forEach(container => {
    // Initial display of the first option badges and the general badge
    showFirstVariantBadges(container);

    const cardContainer = container.closest('.card-container');
    if (cardContainer) {
      cardContainer.querySelectorAll('.swiper-slide a').forEach(link => {
        link.addEventListener('mouseover', function() {
          const variantId = new URL(link.href).searchParams.get('variant');
          if (variantId) {
            hideAllBadges(container); // Hide all badges before updating
            updateBadges(container, variantId);
          }
        });

        link.addEventListener('mouseleave', function() {
          hideAllBadges(container); // Hide all badges when the mouse leaves the option
          showFirstVariantBadges(container); // We show the badges of the first option and one common badge
        });
      });

      // Handling the mouse leaving the container, returning the display of the first option badges and the general badge
      cardContainer.addEventListener('mouseleave', function() {
        hideAllBadges(container); // Hide all badges
        showFirstVariantBadges(container); // We show the badges of the first option and one common badge
      });
    }
    // console.log('link', container.closest('.card-container'));
    // Handling hover on options within the current container

  });
});
